import { jsxs as r, jsx as l } from "react/jsx-runtime";
const t = (o) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...o,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentcolor",
          d: "M8.168 2.445a1 1 0 0 1 1.387-.277L12 3.798l2.445-1.63a1 1 0 1 1 1.11 1.664l-3 2a1 1 0 0 1-1.11 0l-3-2a1 1 0 0 1-.277-1.387"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentcolor",
          d: "M8.505 6h-.002a5.502 5.502 0 0 0-3.016 10.097 4 4 0 0 0 1.745 5.488 4 4 0 0 0 4.772-.939 4 4 0 0 0 4.647 1 4 4 0 0 0 1.872-5.547 5.5 5.5 0 1 0-6.518-8.841A5.48 5.48 0 0 0 8.505 6"
        }
      )
    ]
  }
);
export {
  t as default
};
